<li class="list-item btn">
    <h3>{{item.company}}</h3>
</li>